var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Gamifinnopoly Admin")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }